import { render, staticRenderFns } from "./Traceability.vue?vue&type=template&id=0784678a&scoped=true"
import script from "./Traceability.vue?vue&type=script&lang=js"
export * from "./Traceability.vue?vue&type=script&lang=js"
import style0 from "./Traceability.vue?vue&type=style&index=0&id=0784678a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0784678a",
  null
  
)

export default component.exports